import { Toc } from '../../js/front/Toc';

document.querySelectorAll( '.b-table-of-content' ).forEach( ( block ) => {

	const tocContainer = block.querySelector( '.toc-wrapper' );
	const headingsContainer = block.closest( '.b-post-content' )?.querySelector( '.b-post-content__article' );
	const headingsTags = block.dataset.headings;
	new Toc( headingsContainer, tocContainer, headingsTags );

} );
